import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { TipoCambio } from '../models/tipocambio';


const BACKEND_URL = environment.apiUrl + '/tcambio/';

@Injectable({
    providedIn: 'root'
})
export class TipocambioService {

    constructor(private http: HttpClient, private router: Router) { }

    obtenerTipocambio(tipocambioPorPagina: number, paginaActual: number): any {
        const queryParams = `?limit=${tipocambioPorPagina}&page=${paginaActual}`;

        return this.http.get(BACKEND_URL + queryParams);
    }

    /**
     * Este metodo obtiene la tipocambio que se desea buscar, recibiendo como parametro su id,
     * Retorna la tipocambio buscada.
     * @param id de la tipocambio que deseas obtener
     */
    obtenerTipoCambio(id: string): Observable<TipoCambio> {
        return this.http.get<TipoCambio>(BACKEND_URL + id);
    }

    obtenerFechaMayor(): Observable<TipoCambio> {
        return this.http.get<TipoCambio>(BACKEND_URL + '/fecha');
    }

    crearTipoCambio(tipocambio: TipoCambio): Observable<TipoCambio> {
        const postData: TipoCambio = {
            id: null,
            mo_fecha: tipocambio.mo_fecha,
            mo_cia: tipocambio.mo_cia,
            mo_tcambio: tipocambio.mo_tcambio,
            mo_moneda: tipocambio.mo_moneda

        };

        return this.http.post<TipoCambio>(BACKEND_URL, postData);
    }

    /**
    * Evalua si la fecha del tipocambio ya existe en el catalogo de tipocambios.
    * @param fechaTipoCambio clave a ser evaluada.
    */
    validarExistenciaTipoCambio(fechaTipoCambio: any, monedaTipoCambio: any): Observable<any> {
        return this.http.get(BACKEND_URL + 'validar/' + fechaTipoCambio + '/' + monedaTipoCambio);
    }

    obtenerMonedas(): any {
        return this.http.get(BACKEND_URL + 'monedas');
    }
}
